import { apiRequest } from "./common";

const inviteMember = async (data) => {
    const response = await apiRequest('post', '/project-member/invite', data);
    return response.data;
};

const acceptRequest = async (data) => {
    const response = await apiRequest('patch', `/project-member/accept`, data);
    return response.data;
};

const rejectRequest = async (data) => {
    const response = await apiRequest('patch', `/project-member/decline`, data);
    return response.data;
};


const getMemberList = async (projectId) => {
    const response = await apiRequest('get', `/project-member/project/${projectId}?invite_status=ACCEPTED`);
    return response.data;
};

export {
    inviteMember,
    rejectRequest,
    acceptRequest,
    getMemberList
}